import styled from 'styled-components'

import media from 'media'

import TopRightVignette from 'components/page/Section/assets/vignette/TopRightVignette'
import TopRightSmallVignette from 'components/page/Section/assets/vignette/TopRightSmallVignette'
import BottomLeftVignette from 'components/page/Section/assets/vignette/BottomLeftVignette'

export const TOP_RIGHT = 'top-right'
export const BOTTOM_LEFT = 'bottom-left'

/**
 * assumes that the vignette is placed in a positioned container,
 * this will not work if the parent container is position: static
 */
const Vignette = styled.svg.withConfig({
  shouldForwardProp: (prop) =>
    ['position', 'color', 'size'].indexOf(prop) === -1,
})`
  position: absolute;
  display: none;
  z-index: 5;
  pointer-events: none;

  ${({ position }) => position === 'top-right' && 'top: 0; right: 0;'}
  ${({ position }) => position === 'bottom-left' && 'bottom: 0; left: 0;'}
  ${({ size, position }) =>
    size === 'small' &&
    position === TOP_RIGHT &&
    `
    right: -2px;
    top: -2px;
  `}

  ${media.giant`
    display: block;
  `}
`

export default function useVignette (vignette) {
  const vignetteElement = vignette ? (
    vignette?.position === BOTTOM_LEFT ? (
      <Vignette
        as={vignette?.size === 'small' ? null : BottomLeftVignette}
        position={BOTTOM_LEFT}
        fill={vignette?.color}
        size={vignette?.size}
      />
    ) : (
      <Vignette
        as={
          vignette?.size === 'small' ? TopRightSmallVignette : TopRightVignette
        }
        position={TOP_RIGHT}
        fill={vignette?.color}
        size={vignette?.size}
      />
    )
  ) : null

  return vignetteElement
}
